<template>
    <div>
        <div class="title-bar" v-if="childActivo != null">
            <h1>{{ childActivo.title }}</h1>

            <div class="d-flex gap-2">
                <I18NRouteLink v-for="(hijo, key) in childPorRouteName" :key="key" :to="{ name: key }">
                    <DxButton v-bind="yesButtonProps()" :icon="hijo.icon" :text="hijo.text"
                        :visible="key != childRouteNameActiva && hijo.tienePermiso" />
                </I18NRouteLink>
            </div>
        </div>
        <!-- LOS HIJOS SE VAN A PINTAR AQUI: -->
        <RouterView v-slot="{ Component }">
            <Component :is="Component" @childViewLoaded="onChildViewLoaded" />
        </RouterView>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useIntl } from '@services/i18n'
import { DxButton } from 'devextreme-vue';
import { RouterView, useRoute } from 'vue-router';
import { yesButtonProps } from '@helpers/button-helper';
import I18NRouteLink from '@/.shared/components/i18n/I18NRouteLink.vue';
import { tienePermisoInstalacionesVer, tienePermisoOscilosVer, tienePermisoUsuariosVer, tienePermisoZonasVer } from '@/.shared/helpers/permission-helper';
import { useAuthorization } from '@/.shared/services/auth/authorization';

const intl = useIntl();
const autho = useAuthorization();

const childRouteNameActiva = ref<keyof typeof childPorRouteName>(); // enumerado de string, key de hijoPorViewName
const childActivo = computed(() => {
    return childPorRouteName[childRouteNameActiva.value as string];
});

const childPorRouteName: Record<string, any> = {
    "oscilos-administracion-view": {
        title: intl.i18n.t('administracion.oscilos_administracion.title'),
        icon: "fa fa-signal",
        text: intl.i18n.t('administracion.toolbar.ir_a_administracion_oscilos'),
        tienePermiso: tienePermisoOscilosVer(autho)
    },
    "zonas-administracion-view": {
        title: intl.i18n.t('administracion.zonas_administracion.title'),
        icon: "fa fa-object-group",
        text: intl.i18n.t('administracion.toolbar.ir_a_administracion_zonas'),
        tienePermiso: tienePermisoZonasVer(autho)
    },
    "instalaciones-administracion-view": {
        title: intl.i18n.t('administracion.instalaciones_administracion.title'),
        icon: "fa-solid fa-location-dot",
        text: intl.i18n.t('administracion.toolbar.ir_a_administracion_instalaciones'),
        tienePermiso: tienePermisoInstalacionesVer(autho)
    },
    "usuarios-administracion-view": {
        title: intl.i18n.t('administracion.usuarios_administracion.title'),
        icon: "fa fa-users",
        text: intl.i18n.t('administracion.toolbar.ir_a_administracion_usuarios'),
        tienePermiso: tienePermisoUsuariosVer(autho)
    },
};

function onChildViewLoaded(childRouteName: string): void {
    childRouteNameActiva.value = childRouteName;
}
</script>